import '@ncino/styles/gator'
import Vue from 'vue'
import { toasterService } from '@ncino/web-components/services'

Vue.config.ignoredElements = Vue.config.ignoredElements || []
if (!Vue.config.ignoredElements.some(e => e instanceof RegExp && e.source === '^ngc-')) {
  Vue.config.ignoredElements.push(/^ngc-/)
}

Vue.prototype.$toasterService = toasterService

if (!window.__ncinoComponentsPromise) {
  window.__ncinoComponentsPromise = null
}

export function ensureNcinoWebComponents () {
  if (window.__ncinoComponentsPromise) {
    return window.__ncinoComponentsPromise
  }

  window.__ncinoComponentsPromise = import('@ncino/web-components/dist/index.gator.js')
  return window.__ncinoComponentsPromise
}
